export default {
    // Available types: error, success
    type: "error",
    message: "",
    visible: false,
    dismissable: false,
    showCount: 0
};